export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/resume_design.7676c8f.svg";